import Vue from "vue"
import Global from "./styled/global.vue"
import Title from "./styled/title.vue"
import SubTitle from "./styled/subtitle.vue"
import Text from "./styled/text.vue"
import Button from "./styled/button.vue"
import Badge from "./styled/badge.vue"
import Wrapper from "./styled/wrapper"

/* Forms */
import Input from "./styled/forms/input"
import Select from "./styled/forms/select"
import Choose from "./styled/forms/choose"
import Count from "./styled/forms/count"
import Switch from "./styled/forms/switch"
import TimeSelector from "./styled/forms/time-selector"

export const prGlobal = Vue.component("pr-global", Global)
export const prTitle = Vue.component("pr-title", Title)
export const prSubTitle = Vue.component("pr-subtitle", SubTitle)
export const prText = Vue.component("pr-text", Text)
export const prBadge = Vue.component("pr-badge", Badge)
export const prButton = Vue.component("pr-button", Button)
export const prWrapper = Vue.component("pr-wrapper", Wrapper)

/* Forms */
export const prInput = Vue.component("pr-input", Input)
export const prSelect = Vue.component("pr-select", Select)
export const prChoose = Vue.component("pr-choose", Choose)
export const prCount = Vue.component("pr-count", Count)
export const prSwitch = Vue.component("pr-switch", Switch)
export const prTimeSelector = Vue.component("pr-time-selector", TimeSelector)
